import React, { createContext, useState, useEffect } from 'react';

export const ZendeskContext = createContext();

export const ZendeskProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [account, setAccount] = useState(null);
  const [ticketId, setTicketId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = localStorage.getItem('zendesk_user');
    const storedAccount = localStorage.getItem('zendesk_account');
    const storedTicket = localStorage.getItem('zendesk_ticketId');
    
    if (storedUser) setUser(JSON.parse(storedUser));
    if (storedAccount) setAccount(JSON.parse(storedAccount));
    if (storedTicket) setTicketId(storedTicket);
    
    setLoading(false);
  }, []);

  const login = (userData, accountData, token, ticket = null) => {
    localStorage.setItem('zendesk_user', JSON.stringify(userData));
    localStorage.setItem('zendesk_account', JSON.stringify(accountData));
    localStorage.setItem('zendesk_token', token);
    
    if (ticket) {
      localStorage.setItem('zendesk_ticketId', ticket);
      setTicketId(ticket);
    }
    
    setUser(userData);
    setAccount(accountData);
  };

  const logout = () => {
    localStorage.removeItem('zendesk_user');
    localStorage.removeItem('zendesk_account');
    localStorage.removeItem('zendesk_token');
    localStorage.removeItem('zendesk_ticketId');
    
    setUser(null);
    setAccount(null);
    setTicketId(null);
  };

  return (
    <ZendeskContext.Provider value={{ 
      user, 
      account,
      ticketId,
      loading, 
      login, 
      logout 
    }}>
      {children}
    </ZendeskContext.Provider>
  );
};